// extracted by mini-css-extract-plugin
export default {"root":"root--d3YLz","input":"input--ixjC7 micro--DPyuf form-control_size_micro","select":"select--FeFTC","removeBtn":"removeBtn--b9wC0","removeBtnIcon":"removeBtnIcon--Xt5SD"};